import api from './client';

export const inventoryApi = {
  // 在庫一覧取得（製品種別パラメータを追加）
  getList: (factoryScope, query, classcode0, classcode1, classcode2) => {
    const params = new URLSearchParams();
    params.append('factory_scope', factoryScope);
    if (query) {
      params.append('query', query);
    }
    if (classcode0 !== null && classcode0 !== undefined) {
      params.append('classcode0', classcode0);
    }
    if (classcode1 !== null && classcode1 !== undefined) {
      params.append('classcode1', classcode1);
    }
    if (classcode2 !== null && classcode2 !== undefined) {
      params.append('classcode2', classcode2);
    }
    return api.get(`/api/inventory/list?${params.toString()}`);
  },

  // 在庫状況ヘッダー取得
  getSummary: (productDisp, factory) => {
    return api.get(`/api/inventory/${productDisp}/summary?factory=${factory}`);
  },

  // カレンダー取得
  getCalendar: (productDisp, factory, fromDate, toDate) => {
    const params = new URLSearchParams();
    params.append('factory', factory);
    if (fromDate) {
      params.append('from_date', fromDate);
    }
    if (toDate) {
      params.append('to_date', toDate);
    }
    return api.get(`/api/inventory/${productDisp}/calendar?${params.toString()}`);
  },

  // 発注一覧取得
  getPurchaseOrders: (productDisp, factory) => {
    return api.get(`/api/inventory/${productDisp}/purchase-orders?factory=${factory}`);
  },

  // 出荷一覧取得
  getShipments: (productDisp, factory) => {
    return api.get(`/api/inventory/${productDisp}/shipments?factory=${factory}`);
  },

  getStandardStock: (productDisp) =>
    api.get(`/api/inventory/${productDisp}/standard-stock`),

  updateStandardStock: (productDisp, data) =>
    api.patch(`/api/inventory/${productDisp}/standard-stock`, data),

  getStandardStockHistory: (productDisp, limit = 50) =>
    api.get(`/api/inventory/${productDisp}/standard-stock/history?limit=${limit}`),
};
